export const MetricDefinitionConstants = {
  GET_METRIC_DEFINITION: 'METRIC_DEFINITION/GET_METRIC_DEFINITION',
  GET_CHROME_METRICS_SUCCESS: 'METRIC_DEFINITION/GET_CHROME_METRICS_SUCCESS',

  GET_MAPPING_REQUEST: 'METRIC_DEFINITION/GET_MAPPING_REQUEST',
  GET_MAPPING_SUCCESS: 'METRIC_DEFINITION/GET_MAPPING_SUCCESS',
  GET_MAPPING_ERROR: 'METRIC_DEFINITION/GET_MAPPING_ERROR',

  UPDATE_METRICS_DISPLAY_MAPPING: 'METRIC_DEFINITION/UPDATE_METRICS_DISPLAY_MAPPING'
};
